import cx from 'classnames';
import React, { useState, useEffect, useRef } from 'react';
import styles from './context-menu.module.css';

/**
 actionType = {
  action?: () => {},
  value: string | integer
  label: string,
  className?: string
  hidden: boolean
 }
 */
const ContextMenu = ({ actions, callback, text, position = 'left' }) => {
  const [i_was_clicked, setIWasClicked] = useState(false);
  const [show_menu, setShowMenu] = useState(false);
  const [click_location, setClickLocation] = useState({});
  const context_menu_label = useRef(null);
  const context_menu_wrapper = useRef(null);
  const context_menu = useRef(null);

  useEffect(() => {
    window.addEventListener(
      'click',
      (e) => {
        setClickLocation(() => ({
          x: e.pageX,
          y: e.pageY
        }));
        if (show_menu && !i_was_clicked) {
          setShowMenu(() => false);
          setClickLocation(() => ({}));
        }
        if (show_menu) {
          setIWasClicked(() => false);
        }
      },
      { once: true }
    );

    if (context_menu.current && click_location.x) {
      const menu_tray = context_menu.current;

      const { clientHeight: ctx_label_height, clientWidth: ctx_label_width } =
        context_menu_label.current;
      const { height: screen_height, width: screen_width } = window.screen;
      const { clientHeight: tray_height, clientWidth: tray_width } = menu_tray;

      menu_tray.style.top = `${ctx_label_height + 10}px`;
      if (click_location.x + tray_width * 1.5 > screen_width) {
        menu_tray.style.left = 'unset';
        menu_tray.style.right = `-${ctx_label_width}px`;
      }

      if (click_location.y + tray_height * 1.5 > screen_height) {
        menu_tray.style.top = 'unset';
        menu_tray.style.bottom = `${10}px`;
      }
    }
  }, [i_was_clicked]);

  const processGroup = (action_groups) => {
    const group_actions = [];
    for (const action_group of action_groups) {
      const filtered_actions = action_group.filter((action) => !action.hidden);
      if (filtered_actions.length) {
        group_actions.push(filtered_actions);
      }
    }
    return group_actions;
  };

  const renderAction = (action, index) => {
    if (action.hidden) return null;
    if (action && action.action) {
      return (
        <div
          className={cx(styles['gm-context-menu-item'], styles[action.color], action.className)}
          key={index}
          onClick={(e) => selectAction(action.action, e)}
        >
          {action.label}
        </div>
      );
    }

    return (
      <div
        className={cx(styles['gm-context-menu-item'], styles[action.color], action.className)}
        key={index}
        onClick={(e) => selectAction(action.value, e)}
      >
        {action.label}
      </div>
    );
  };

  const selectAction = (action, e) => {
    callback(action);

    toggleShowMenu(e);
  };

  const toggleShowMenu = (e) => {
    setIWasClicked(() => true);
    setShowMenu((show_menu) => !show_menu);
  };

  return (
    <>
      <div
        ref={context_menu_label}
        className={styles['context-menu-label']}
        onClick={(e) => toggleShowMenu(e)}
      >
        {actions && (
          <div className={styles['gm-action-contaxt-menu-wrapper']} ref={context_menu_wrapper}>
            {show_menu && (
              <div ref={context_menu} className={styles['gm-action-context-menu']}>
                {processGroup(actions).map((group, index) => (
                  <div key={`context-item-${index}`} className={styles['gm-context-menu-group']}>
                    {group.map((action, index) => renderAction(action, index))}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {text || '...'}
      </div>
    </>
  );
};

export default ContextMenu;
